// Publics views
import AuthLayout from '@/router/layouts/Auth.layout.vue';
import LoginView from '@/router/views/auth/Login.view.vue';
import RegisterView from '@/router/views/auth/Register.view.vue';
import ForgotView from '@/router/views/auth/Forgot.view.vue';
import ConfirmView from '@/router/views/auth/Confirm.view.vue';
import ResetPassword from '@/router/views/auth/ResetPassword.view.vue';
import RegisterInvited from '@/router/views/auth/RegisterInvited.view.vue';
import Oauth from '@/router/views/auth/Oauth.view.vue';
import DeleteAccount from '@/router/views/auth/DeleteAccount.view.vue';
import PrivacyPolicy from '@/router/views/auth/PrivacyPolicy.view.vue';
import VulnerabilityPolicy from '@/router/views/auth/VulnerabilityPolicy.view.vue';
import SecuritySupportTerms from '@/router/views/auth/SecuritySupportTerms.view.vue';

// Privates views
import MainLayout from '@/router/layouts/Main.layout.vue';
import HomeView from '@/router/views/main/Home.view.vue';
import UnitView from '@/router/views/main/Unit.view.vue';
import SchedulesView from '@/router/views/main/Schedule.view.vue';
import ScenesView from '@/router/views/main/Scene.view.vue';
import WeatherView from '@/router/views/main/Weather.view.vue';
import UnitsView from '@/router/views/main/Units.view.vue';
import UsersView from '@/router/views/main/Users.view.vue';
import AccountView from '@/router/views/main/Account.view.vue';
import SettingsView from '@/router/views/main/Settings.view.vue';
import SupportView from '@/router/views/main/Support.view.vue';
import DevicesView from '@/router/views/main/Devices.view.vue';
import UserFeaturesView from '@/router/views/main/UserFeatures.view.vue';
import AddUnitView from '@/router/views/main/AddUnit.view.vue';

// Error views
import ErrorLayout from '@/router/layouts/Error.layout.vue';
import NotFoundErrorView from '@/router/views/error/NotFound.view.vue';
import DefaultErrorView from '@/router/views/error/Default.view.vue';
import OfflineErrorView from '@/router/views/error/Offline.view.vue';

export default [
  {
    path: '/',
    redirect: {
      name: 'home',
    },
  },

  // Publics routes
  {
    path: '/auth',
    component: AuthLayout,
    redirect: {
      name: 'login',
    },
    children: [
      {
        path: '/deleteAccount',
        name: 'deleteAccount',
        component: DeleteAccount,
      },
      {
        path: '/privacyPolicy',
        name: 'privacyPolicy',
        component: PrivacyPolicy,
      },
      {
        path: '/vulnerabilityPolicy',
        name: 'vulnerabilityPolicy',
        component: VulnerabilityPolicy,
      },
      {
        path: '/securitySupportTerms',
        name: 'securitySupportTerms',
        component: SecuritySupportTerms,
      },
      {
        path: 'login',
        name: 'login',
        component: LoginView,
        meta: {
          onlyWhenLoggedOut: true,
        },
      },
      {
        path: 'register',
        name: 'register',
        component: RegisterView,
        meta: {
          onlyWhenLoggedOut: true,
        },
      },
      {
        path: 'forgot',
        name: 'forgot',
        component: ForgotView,
        meta: {
          onlyWhenLoggedOut: true,
        },
      },
      {
        path: '/confirm/:token',
        name: 'confirm',
        component: ConfirmView,
      },
      {
        path: '/resetPassword/:token',
        name: 'resetPassword',
        component: ResetPassword,
        meta: {
          onlyWhenLoggedOut: true,
        },
      },
      {
        path: '/registerInvited/:token',
        name: 'registerInvited',
        component: RegisterInvited,
        meta: {
          onlyWhenLoggedOut: true,
        },
      },
      {
        path: '/oauth',
        name: 'oauth',
        component: Oauth,
        meta: {
          onlyWhenLoggedOut: true,
        },
      },
    ],
  },

  // Privates routes
  {
    path: '/main',
    component: MainLayout,
    redirect: {
      name: 'home',
    },
    meta: {
      private: true,
    },
    children: [
      {
        path: '/',
        name: 'home',
        component: HomeView,
      },
      {
        path: 'unit/:installationID/:mac/:ACSMode?',
        name: 'unit',
        component: UnitView,
      },
      {
        path: 'units',
        name: 'units',
        component: UnitsView,
      },
      {
        path: 'schedules/:day?',
        name: 'schedules',
        component: SchedulesView,
      },
      {
        path: 'scenes',
        name: 'scenes',
        component: ScenesView,
      },
      {
        path: 'weather',
        name: 'weather',
        component: WeatherView,
      },
      {
        path: 'users',
        name: 'users',
        component: UsersView,
      },
      {
        path: '/settings',
        name: 'settings',
        component: SettingsView,
      },
      {
        path: '/account',
        name: 'account',
        component: AccountView,
      },
      {
        path: '/support',
        name: 'support',
        component: SupportView,
      },
      {
        path: '/devices',
        name: 'devices',
        component: DevicesView,
      },
      {
        path: 'userFeatures',
        name: 'userFeatures',
        component: UserFeaturesView,
      },
      {
        path: 'addUnit',
        name: 'addUnit',
        component: AddUnitView,
      },
    ],
  },

  // Routes error
  {
    path: '/error',
    component: ErrorLayout,
    children: [
      {
        path: '/',
        name: 'default',
        component: DefaultErrorView,
      },
      {
        path: '/404',
        name: '404',
        component: NotFoundErrorView,
      },
      {
        path: '/offline',
        name: 'offline',
        component: OfflineErrorView,
      },
    ],
  },

  // Routes not found
  {
    path: '*',
    redirect: {
      name: '404',
    },
  },
];
